import Papa from "papaparse";

export const parseWebullCSV = (csvContent) => {
  console.log("Starting Webull CSV parse");

  const results = Papa.parse(csvContent, {
    header: true,
    skipEmptyLines: true,
    dynamicTyping: false, // Changed to false to handle strings first
  });

  console.log("Parsed data:", results.data);

  if (!results.data || !results.data.length) {
    console.error("No data found in CSV");
    return { trades: [], accountBalance: 0, dailyPnL: 0 };
  }

  let tempTrades = [];
  let trades = [];

  // Filter for filled orders only and convert to standard format
  const filledOrders = results.data.filter((order) => {
    if (!order || !order.Status) return false; // Added null check
    return order.Status === "Filled";
  });

  console.log("Filtered filled orders:", filledOrders);

  filledOrders.forEach((order) => {
    if (
      !order ||
      !order.Symbol ||
      !order.Side ||
      !order["Total Qty"] ||
      !order["Avg Price"]
    ) {
      console.log("Skipping invalid order:", order);
      return;
    }

    try {
      tempTrades.push({
        date: order["Filled Time"],
        action: order.Side.toUpperCase(),
        symbol: order.Symbol,
        quantity: parseInt(order["Total Qty"]),
        price: parseFloat(order["Avg Price"]),
        name: order.Name || "",
      });
    } catch (error) {
      console.error("Error processing order:", error, order);
    }
  });

  // Sort trades by date
  tempTrades.sort((a, b) => new Date(a.date) - new Date(b.date));

  // Find and pair trades
  for (let i = 0; i < tempTrades.length; i++) {
    const currentTrade = tempTrades[i];
    if (!currentTrade) continue; // Skip if null

    // Look for matching closing trade
    for (let j = i + 1; j < tempTrades.length; j++) {
      const potentialMatch = tempTrades[j];
      if (!potentialMatch) continue; // Skip if null

      if (
        currentTrade.symbol === potentialMatch.symbol &&
        currentTrade.action !== potentialMatch.action
      ) {
        // Determine entry and exit points
        const entry =
          currentTrade.action === "BUY" ? currentTrade : potentialMatch;
        const exit =
          currentTrade.action === "SELL" ? currentTrade : potentialMatch;

        // Calculate P&L
        const pnl = (exit.price - entry.price) * entry.quantity;

        const trade = {
          date: new Date(entry.date).toISOString(),
          symbol: entry.symbol,
          direction: entry.action === "BUY" ? "LONG" : "SHORT",
          entryPrice: entry.price,
          exitPrice: exit.price,
          quantity: entry.quantity,
          pnl: pnl,
          broker: "webull",
          status: pnl >= 0 ? "WIN" : "LOSS",
          name: entry.name,
        };

        trades.push(trade);

        // Mark both trades as processed
        tempTrades[i] = null;
        tempTrades[j] = null;
        break;
      }
    }
  }

  // Clean up any null values
  trades = trades.filter(Boolean);

  console.log("Final processed trades:", trades);

  return {
    trades,
    accountBalance: 0,
    dailyPnL: trades.reduce((sum, trade) => sum + trade.pnl, 0),
  };
};

export const validateWebullFormat = (csvContent) => {
  const results = Papa.parse(csvContent, { header: true });

  const requiredColumns = [
    "Symbol",
    "Side",
    "Status",
    "Total Qty",
    "Avg Price",
    "Filled Time",
  ];

  const headers = results.meta.fields || [];
  const hasRequiredColumns = requiredColumns.every((col) =>
    headers.includes(col)
  );

  return {
    isValid: hasRequiredColumns,
    message: hasRequiredColumns
      ? "Valid Webull format"
      : "Invalid file format. Please upload a Webull orders record file.",
  };
};
